import gql from "graphql-tag";

export default gql`
  query legalMentions($siteId: [QueryArgument]) {
    page: entry(section: "disclaimer", siteId: $siteId) {
      title
      ... on disclaimer_disclaimer_Entry {
        legalContent
        seo {
          description
          title
        }
      }
    }
  }
`;
